import React from 'react';
import { Link, useLocation } from "react-router-dom";

const Header = () => {
	const location = useLocation();
	return (
		<header>
	      <nav className="navbar navbar-expand-lg navbar-dark padding-top-sm">
	        <div className="container">
				<Link to="/">
					<img src="images/Meas-Sol_logo.png" alt="Meas-Sol"/>
				</Link>
				<button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
				<span className="navbar-toggler-icon"></span>
				</button>
				<div className="collapse navbar-collapse" id="navbarNav">
					<ul className="navbar-nav ms-auto">
						<li className="nav-item padding-left-base">
							<Link to="/solutions" className={`nav-link ${location.pathname === "/solutions" ? "active" : ""}`}>
							  Solutions
							</Link>
						</li>
						<li className="nav-item padding-left-base">
							<Link to="/usecase" className={`nav-link ${location.pathname === "/usecase" ? "active" : ""}`}>
							  Use Cases
							</Link>
						</li>
						<li className="nav-item padding-left-base">
							<Link to="/aboutus" className={`nav-link ${location.pathname === "/aboutus" ? "active" : ""}`}>
							  About Us
							</Link>
						</li>
						<li className="nav-item padding-left-base padding-right-base">
							<Link to="/contact" className={`nav-link ${location.pathname === "/contact" ? "active" : ""}`}>
							  Contact Us
							</Link>
						</li>
					</ul>
					<span>
						<Link to="/survey" className="nav-link">
							<button type="button" className="survey-btn">
								Take Our Survey
							</button>
						</Link>
					</span>
				</div>
	        </div>
	      </nav>
	    </header>
	);
}

export default Header;